import { Box } from "@mui/material";
import BookmarkPlan from "components/common/Bookmark";
import { clearFilters } from "components/common/Filters/Filters.slice";
import KeyMetrics from "components/common/KeyMetrics/KeyMetrics";
import BasicTable from "components/common/Table";
import Typography from "components/common/Typography";
import { setProgressInfoSummary } from "components/features/Progress/Progress.slice";
import { useTranslate } from "hooks/useTranslate";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { DEFAULT_CORP_INNCODE, corpViewTypes, sortableProperties } from "utils/CommonConstants";
import {
  functionalAreaIdToName,
  functionalAreaIdsToNames,
  getKeyMetricsPlansData,
  getKeyMetricsPlansDataSC,
  getMoreValues,
  getSourceName,
  getTableColor,
  isBookmarked
} from "utils/CommonFunctions";
import { tableauURL } from "utils/URLConstants";
import {
  fetchCorpDashboardPlansAsync,
  fetchCorpDashboardPlansOverviewAsync,
  reset,
  setSorting
} from "../CorpUser.Slice";
import { getAllBreakupLists, getmyListType } from "../MyLists/MyLists";
import TableEdit from "../MyLists/TableEdit";
import "./CorpView.scss";
import { dashboardPlansHeaders, plansHeaders, plansHeadersSC } from "./TableHeadersConfig";

const PlansData = ({ view, selectedListType, selectedList }: any) => {
  const plansList = useAppSelector((state) => state.CorpDashboard.myView.plans.list);
  const functionalAreaList: any = useAppSelector((state) => state.functionalAreas.list);
  const overview = useAppSelector((state) => state.CorpDashboard.myView.plans.overview);
  const filterRequestPayload = useAppSelector((state) => state.filters.filterRequestPayload);
  const isFilterApiCalled = useAppSelector((state) => state.filters.isFilterApiCalled);
  const filterAppliedView = useAppSelector((state) => state.filters.view);
  const listCategory = useAppSelector((state) => state.CorpDashboard.myListsSelected.listCategory);
  const [searchedText, setSearchedText] = useState("");
  const selectedTab = useAppSelector((state) => state.CorpDashboard.selectedTabs?.[view]);
  const sorting = useAppSelector((state) => state.CorpDashboard.sorting);
  const recentSortingApplied =
    sorting?.[view]?.[selectedTab === 1 ? "plansSort" : "propertiesSort"]?.["recentSortingApplied"];

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const translate = useTranslate();

  const myListType = getmyListType(selectedListType, selectedList?.name);

  const apiCall = (payload: any) => {
    let payloadData = { ...payload, view: view };
    payloadData =
      view === corpViewTypes.myList
        ? { ...payloadData, myListType: myListType, myListId: selectedList?.id }
        : payloadData;
    const sorting = { sort: { ...recentSortingApplied } };

    payloadData = { ...payloadData, ...sorting };
    dispatch(fetchCorpDashboardPlansAsync({ ...payloadData, view: view }));
    dispatch(
      fetchCorpDashboardPlansOverviewAsync({
        ...payloadData
      })
    );
  };

  useEffect(() => {
    if (isFilterApiCalled && filterAppliedView === view) {
      const payload = selectedListType !== "dynamic" && isEmpty(filterRequestPayload) ? {} : filterRequestPayload;
      apiCall(payload);
    }
  }, [isFilterApiCalled, filterRequestPayload, filterAppliedView]);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, []);
  const getInputDetail = (val: string) => {
    let payloadData =
      view === corpViewTypes.myList
        ? { ...filterRequestPayload, myListType: myListType, myListId: selectedList?.id }
        : filterRequestPayload;
    const sorting = { sort: { ...recentSortingApplied } };

    payloadData = { ...payloadData, ...sorting };
    dispatch(fetchCorpDashboardPlansAsync({ ...payloadData, view: view, searchText: val }));
    setSearchedText(val);
  };

  const getRowData = (plansList: any) => {
    return plansList?.map((plan: any) => {
      return {
        data: getChildObject(plan, plansList)
      };
    });
  };

  const getChildObject = (plan: any, plansList: any) => {
    const type = "plan";
    let data: any = [
      {
        content: (
          <Box
            onClick={() => {
              {
                if (selectedListType === "consultant") {
                  navigate(`/progressInfo/${type}/${selectedList?.id}?cmsId=${plan?.planCmsId}`, {
                    state: {
                      isMyLists: true,
                      defaultTab: 1,
                      innCodes: plan?.implementedInncodes
                    }
                  });
                  dispatch(setProgressInfoSummary(plan));
                } else
                  navigate(`/plandetails/${plan?.planCmsId}`, {
                    state: {
                      innCode: DEFAULT_CORP_INNCODE,
                      isMyLists: true,
                      defaultTab: 1,
                      innCodes: plan?.implementedInncodes,
                      redirectFromDashboard: true
                    }
                  });
                dispatch(clearFilters({ skipModified: true }));
              }
            }}
            sx={{
              textDecoration: "none",
              cursor: "pointer",
              color: tokens.Text.General.PrimaryHeadline,
              fontWeight: "700"
            }}
          >
            {plan?.planName || plan?.myPlanName}
          </Box>
        ),
        showBold: true
      },
      {
        content: getMoreValues(functionalAreaIdsToNames(plan.functionalAreas)),
        tooltip: {
          title: "Functional Areas",
          list: plan?.functionalAreas?.map((FA: any) => {
            return { name: functionalAreaIdToName(FA, functionalAreaList) };
          })
        }
      },
      {
        content: getMoreValues(plan?.planSources?.map((source: any) => getSourceName(source))),

        tooltip: {
          list: plan?.planSources?.map((src: any) => {
            return { name: getSourceName(src) };
          })
        }
      },

      {
        content:
          listCategory === "consultant" && view === "myList" ? plan.assigneesCount : plan.implementedPropertiesCount
      }
    ];
    if (view === "myList") {
      data.push({
        content: geStatusValues(plan?.implementedPlansCountStatusBreakUp)
      });
      data.push({
        content: (
          <BookmarkPlan
            innCodeForPayload={DEFAULT_CORP_INNCODE}
            cmsId={plan?.planCmsId}
            isBookmarked={isBookmarked(plan?.planCmsId, DEFAULT_CORP_INNCODE)}
            onClickFunction={() => {
              if (selectedList?.name === "Bookmarked Plans") {
                const payload =
                  selectedListType !== "dynamic" && isEmpty(filterRequestPayload) ? {} : filterRequestPayload;
                apiCall(payload);
              }
            }}
          />
        )
      });
    }

    return data;
  };

  const geStatusValues = (statusBreakUp: any) => {
    const status = getAllBreakupLists(statusBreakUp);

    return (
      <>
        {status?.map((item: any) => {
          return (
            <div style={{ color: getTableColor(item?.name), whiteSpace: "nowrap" }}>
              <Typography component={"span"} variant={"body2"} showBold>
                {item.value < 10 ? "0" : ""}
                {`${item.value ?? "00"}  `}
              </Typography>
              <Typography component={"span"}>
                {item?.name} {item?.isShowStar > 0 ? "*" : ""}
              </Typography>
            </div>
          );
        })}
      </>
    );
  };
  const handlePlansSorting = async (headerName: string) => {
    let header = sortableProperties[headerName];
    let sortedOrder = recentSortingApplied.order === "asc" ? "desc" : "asc";
    const payloadData = {
      ...filterRequestPayload,
      myListType: myListType,
      myListId: selectedList?.id,
      view: view,
      searchText: searchedText
    };
    await dispatch(
      fetchCorpDashboardPlansAsync({
        ...payloadData,
        sort: {
          property: header,
          order: header == recentSortingApplied.property ? sortedOrder : "asc"
        }
      })
    );
    dispatch(
      setSorting({
        type: view,
        tab: selectedTab === 1 ? "plansSort" : "propertiesSort",
        header: sortableProperties[headerName],
        order: header === recentSortingApplied.property ? sortedOrder : "asc"
      })
    );
  };
  return (
    <div className="corp-view-tab-data-component">
      <KeyMetrics
        helperText={
          listCategory === "consultant" && view === "myList"
            ? "*Results displayed are for highlighted list"
            : "*Last 30 Days"
        }
        hyperLink={
          view === "dashboard"
            ? {
                link: tableauURL,
                content: (
                  <Typography variant={"label"} color={tokens.Text.General.Color}>
                    Go to Tableau for full insights.
                  </Typography>
                )
              }
            : {}
        }
        keyMetricsData={
          listCategory === "consultant" && view === "myList"
            ? getKeyMetricsPlansDataSC(overview)
            : getKeyMetricsPlansData(overview)
        }
      />
      <TableEdit
        view={view}
        selectedListType={selectedListType}
        getInputDetails={(val: string) => getInputDetail(val)}
      />
      <BasicTable
        noDataMessage={translate("common.noResults")}
        data={{
          headers:
            view === "dashboard"
              ? dashboardPlansHeaders
              : listCategory === "consultant"
              ? plansHeadersSC
              : plansHeaders,
          rows: getRowData(plansList)
        }}
        handleSorting={handlePlansSorting}
      />
    </div>
  );
};
export default React.memo(PlansData);
